import {
	CheckboxCompat as Checkbox,
	DirectionalHint,
	ICheckboxProps,
	IRenderFunction,
} from 'components/FluentUICompat';
import React from 'react';
import {
	TooltipRendererFields,
	TooltipRendererCreatorService,
} from '../../TooltipRendererCreator.service';
import {TooltipWithCheckboxLabel} from './TooltipWithCheckboxLabel';
import {TooltipOptionsForComponentOrColumn} from 'features/localizedTooltips/LocalizedTooltipHost';

export type PropsOfCheckboxWithTooltip = ICheckboxProps &
	TooltipOptionsForComponentOrColumn;

/**
 * We created this component because the checkbox needs a special renderer to
 * pass the correct accessibility property.
 */
export function CheckboxWithTooltip({
	tooltipHostProps,
	...checkboxProps
}: PropsOfCheckboxWithTooltip): React.ReactElement {
	const {getCallRendererIfDefaultOneExists} =
		new TooltipRendererCreatorService();

	const renderLabelWithDefaultRenderer = ({
		props,
		defaultRender,
	}: TooltipRendererFields<null, ICheckboxProps>): React.ReactElement => {
		return (
			<TooltipWithCheckboxLabel
				originalComponentProps={props}
				defaultRender={defaultRender}
				directionalHint={DirectionalHint.leftCenter}
				{...tooltipHostProps}
			/>
		);
	};

	const renderLabel: IRenderFunction<ICheckboxProps> =
		getCallRendererIfDefaultOneExists(null, renderLabelWithDefaultRenderer);

	return <Checkbox onRenderLabel={renderLabel} {...checkboxProps} />;
}
